import { FC } from "react";

import {
	EnhancedDatePicker,
	EnhancedIOSSwitchRHFWithLabel,
	ITest,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
	SinNumberRHF,
} from "@websential/cosmic-v20";

import { FieldWrapper } from "../../../FieldWrapper/FieldWrapper";
import { Box } from "@mui/material";

interface IEmployeeInfoSetupFieldsPanel extends ITest {
	onDateOfBirthChangeHandler: (selectedDate: any) => void;
}

export const EmployeeInfoSetupFieldsPanel: FC<
	IEmployeeInfoSetupFieldsPanel
> = ({ onDateOfBirthChangeHandler, testId }) => {
	return (
		<>
			{/* <FieldWrapper>
				<EnhancedIOSSwitchRHFWithLabel
					name="reflectMasterData"
					checked={false}
					testId="reflectInEmployee"
					label="Reflect in Employee"
					labelPosition={LabelPosition.Top}
				/>
			</FieldWrapper> */}
			{/* <RHookFormTextFieldWithLabel
          label="Social Insurance"
          id="uniqueIdentifier"
          testId={`${testId}-social-insurance`}
          labelPosition={LabelPosition.Top}
          required
        /> */}
			<SinNumberRHF
				id="socialInsuranceNumber"
				label="Social Insurance"
				required={true}
				labelPosition={LabelPosition.Top}
				labelColumns={4}
				fieldColumns={8}
				testId="socialInsuranceNumber"
			/>
			<RHookFormTextFieldWithLabel
				label="First Name"
				id="firstName"
				testId={`${testId}-first-name`}
				labelPosition={LabelPosition.Top}
				required
			/>
			{/* <RHookFormTextFieldWithLabel
          label="Initials"
          id="initials"
          testId={`${testId}-initials`}
          labelPosition={LabelPosition.Top}
        /> */}
			<RHookFormMaskedTextFieldWithLabel
				label="Initials"
				id="initials"
				testId={`${testId}-initials`}
				labelPosition={LabelPosition.Top}
				inputMaskPattern={"a"}
			/>
			<RHookFormTextFieldWithLabel
				label="Last Name"
				id="lastName"
				testId={`${testId}-last-name`}
				labelPosition={LabelPosition.Top}
				required
			/>
			<RHookFormDatePicker
				name="dateOfBirth"
				testId="date-of-birth"
				label="Date of Birth"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				// required
				labelColumns={4}
				fieldColumns={8}
				// onDateSelectionChangeHandler={onDateOfBirthChangeHandler}
			/>
		</>
	);
};
